export enum MessageKind {
	CAPTURE_USER_EVENTS = 'bridge::capture_user_events',
	CLOSE_APP           = 'bridge::close_app',
	DISABLE_TILE        = 'bridge::disable_tile',
	ENABLE_TILE         = 'bridge::enable_tile',
	GET_OPEN_ENCOUNTER  = 'bridge::get_open_encounter',
	GET_PAGE            = 'bridge::get_page',
	GET_PATIENT_INFO    = 'bridge::get_patient',
	GET_PLATFORM        = 'bridge::get_platform',
	HIDE_TILE           = 'bridge::hide_tile',
	LOGIN               = 'bridge::login',
	LOGOUT              = 'bridge::logout',
	SET_OPEN_ENCOUNTER  = 'bridge::set_open_encounter',
	PUSH_NOTIFICATION   = 'bridge::push_notification',
	RELEASE_USER_EVENTS = 'bridge::release_user_events',
	SET_BADGE_COUNT     = 'bridge::set_badge_count',
	SET_PATIENT_INFO    = 'bridge::set_patient',
	SHOW_TILE           = 'bridge::show_tile',

	DEPRECATED_GET_AUTH_USER = 'bridge::get_auth_user',
}

export type Message = {
	appId?: string
	data?: unknown
	sdkVersion: string
}
type MessageInternal = Message & { event: MessageKind, eventType: typeof MAGIC_VALUE, srcWindow: Window }

type Off = () => void
let numSubs = 0

export function on(event: MessageKind, handle: (msg: Message, srcWindow: Window) => void): Off {
	// Start listening for messages on first subscription.
	if (numSubs++ === 0) {
		window.addEventListener('message', messageListener, false)
	}

	// Listen for custom event triggered by message listener.
	const eventHandler = (evt: CustomEvent<MessageInternal>) => handle(evt.detail, evt.detail.srcWindow)
	window.addEventListener(event, eventHandler)

	return () => {
		window.removeEventListener(event, eventHandler)

		// Stop listening for messages when there are no more subscriptions.
		if(--numSubs === 0) {
			window.removeEventListener('message', messageListener)
		}
	}
}

const MAGIC_VALUE = 'BRIDGE_EVENT' // used for basic/preliminary filtering of messages

function messageListener(event: MessageEvent<Message>) {
	if (typeof event.data !== 'string') return
	let payload: MessageInternal
	try {
		payload = JSON.parse(event.data)
	} catch {
		return
	}
	if (payload.eventType !== MAGIC_VALUE) return
	payload.srcWindow = event.source as Window
	window.dispatchEvent(new CustomEvent<Message>(payload.event, { detail: payload }))
}

export function send(dest: Window, msgKind: MessageKind, message: Message) {
	const messageInternal: Omit<MessageInternal, 'srcWindow'> = { event: msgKind, eventType: MAGIC_VALUE, ...message }
	dest.postMessage(JSON.stringify(messageInternal), '*')
}
